module.exports = __webpack_public_path__ + "static/media/trash_white_icon.f33033f2.svg";